import { X, Crown, ArrowRight, AlertCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function SubscriptionLimitModal({ isOpen, onClose, errorMessage }) {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleViewPlans = () => {
    onClose();
    navigate('/pricing');
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-fadeIn">
      <div className="bg-white rounded-[32px] shadow-2xl max-w-md w-full p-8 relative animate-slideUp">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-6 right-6 text-gray-400 hover:text-gray-600 transition-colors"
          aria-label="Close"
        >
          <X className="w-6 h-6" />
        </button>

        {/* Icon */}
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 bg-gradient-to-br from-orange-100 to-orange-200 rounded-3xl flex items-center justify-center">
            <Crown className="w-10 h-10 text-orange-500" />
          </div>
        </div>

        {/* Title */}
        <h2 className="text-2xl font-bold text-gray-900 text-center mb-3">
          Interview Limit Reached
        </h2>

        {/* Description */}
        <div className="bg-orange-50 border border-orange-100 rounded-2xl p-4 mb-6">
          <div className="flex items-start gap-3">
            <AlertCircle className="w-5 h-5 text-orange-500 flex-shrink-0 mt-0.5" />
            <p className="text-sm text-gray-700 leading-relaxed">
              {errorMessage || "You've reached your monthly interview limit. Upgrade your plan to continue practicing and ace your next interview!"}
            </p>
          </div>
        </div>

        {/* Benefits List */}
        <div className="space-y-3 mb-6">
          <div className="flex items-center gap-3 text-sm text-gray-600">
            <div className="w-1.5 h-1.5 bg-orange-500 rounded-full"></div>
            <span>Unlimited mock interviews</span>
          </div>
          <div className="flex items-center gap-3 text-sm text-gray-600">
            <div className="w-1.5 h-1.5 bg-orange-500 rounded-full"></div>
            <span>Detailed AI feedback on every answer</span>
          </div>
          <div className="flex items-center gap-3 text-sm text-gray-600">
            <div className="w-1.5 h-1.5 bg-orange-500 rounded-full"></div>
            <span>Access to all premium features</span>
          </div>
        </div>

        {/* Buttons */}
        <div className="flex flex-col gap-3">
          <button
            onClick={handleViewPlans}
            className="w-full btn-orange py-4 rounded-2xl font-semibold text-base shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all flex items-center justify-center gap-2"
          >
            View Plans
            <ArrowRight className="w-5 h-5" />
          </button>
          <button
            onClick={onClose}
            className="w-full bg-gray-100 text-gray-700 py-4 rounded-2xl font-semibold text-base hover:bg-gray-200 transition-colors"
          >
            Maybe Later
          </button>
        </div>
      </div>
    </div>
  );
}
